import { render, staticRenderFns } from "./FormAcomodaciones.vue?vue&type=template&id=6185a4a3&"
import script from "./FormAcomodaciones.vue?vue&type=script&lang=js&"
export * from "./FormAcomodaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports